export default __webpack_public_path__ + "static/media/497789.110a375b.svg";